const V2TempPrefix = '/v2';

export const Login = '/account/login';

export const Dashboard = '/';
export const V2Dashboard = `${V2TempPrefix}/dashboard`;

export const Account = `/account-details`;

export const Transactions = `/transaction-management`;
export const V2Transactions = `${V2TempPrefix}/transactions`;
export const TransactionsChargeback = `${Transactions}/chargeback`;
export const TransactionsRefund = `${Transactions}/refund`;
export const TransactionsCreateRefund = `${Transactions}/create-refund`;
export const TransactionsCreateInvoice = `${Transactions}/create-invoice`;

export const RejectedTransactions = `/rejected-transaction`;

export const PaymentGates = `/payment-gates`;

export const Reports = `/reports`;
export const ReportsAll = `${Reports}/all`;
export const ReportsSaved = `${Reports}/saved`;

export const Withdrawals = `/withdrawals`;

export const Help = `/help`;

export const Settings = `/settings`;
